module.exports = __webpack_public_path__ + "img/stock11.87f976e1.png";